import getPermissions from "./utils/getPermissions";
import omitEmpty from "./utils/omitEmpty";
export default {
    get: function (token, auth) {
        var users = getPermissions(token, "ownership", ["users"], ["read"]);
        var rewardWallet = !auth.featureFlags.isRewardDisabled
            && getPermissions(token, "rewards-wallet", ["rewards-wallets"], ["create", "read"])
            && getPermissions(token, "recognition", ["recognition"], ["read"]);
        var tenantWallet = getPermissions(token, "tenant-wallet", ["topup"], ["create", "read"]);
        var permission = {
            users: users,
            rewardWallet: rewardWallet,
            tenantWallet: tenantWallet
        };
        return omitEmpty(permission);
    }
};
